// ─── Zentrale de-AT-Formatierung ──────────────────────────────────────────────
// Single source of truth für Zahlen / Währung / Prozent im Frontend.
// Vorher rollte jedes Modul sein eigenes toFixed()/toLocaleString() — mit der
// Folge, dass Dezimalzahlen mal mit englischem Punkt ("5.0 Jahre", "409.3 %")
// und mal mit de-AT-Komma erschienen, und das €-Zeichen mal als Prefix
// ("€ 1 234") und mal als Suffix ("1 234 €") stand. Hier vereinheitlicht.

const LOCALE = "de-AT";

/** Zahl mit fixer Nachkommastellen-Zahl im de-AT-Format. Null/NaN → „—". */
export function num(value: number | null | undefined, digits = 0): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return value.toLocaleString(LOCALE, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/** Betrag in Euro — €-Zeichen immer als Suffix (einheitliche de-AT-Konvention). */
export function eur(value: number | null | undefined, digits = 0): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return `${num(value, digits)} €`;
}

/** Prozentwert (bereits in Prozent, z.B. 409.3 → „409,3 %"). */
export function pct(value: number | null | undefined, digits = 1): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return `${num(value, digits)} %`;
}
